import { DataContent } from "@/components/ui/DataContent";
import { ExpandedContent } from "@/components/ui/table-final-saviour/Table/TableExpandable";
import { DescriptionsSection } from "@/components/widgets/tables/service-history/ExpandedContent/sections/DescriptionsSection";
import { ExpensesSection } from "@/components/widgets/tables/service-history/ExpandedContent/sections/ExpensesSection";
import { PartsSection } from "@/components/widgets/tables/service-history/ExpandedContent/sections/PartsSection";
import { filterDataBySectionKey } from "@/components/widgets/tables/service-history/ExpandedContent/service-history-expanded-content.utils";
import { useDataSource } from "@/features/data-source/useDataSource";
import { ServiceHistoryExpandedDataSourceRow } from "@/pages/DeviceDetailPage/widgets/ServiceHistoryWidget/service-history-widget.types";

type Props = {
    row: {
        OrderNumber: string;
    };
};

export const ServiceHistoryExpandedContent = (props: Props) => {
    const orderNumber = props.row.OrderNumber;

    const dataSource = useDataSource<ServiceHistoryExpandedDataSourceRow[]>("service-history-expanded-detail", {
        orderNumber,
    });

    const data = dataSource?.data ?? [];

    const expensesData = filterDataBySectionKey(data, "Expenses");
    const partsData = filterDataBySectionKey(data, "Parts");
    const descriptionsData = filterDataBySectionKey(data, "Descriptions");

    return (
        <ExpandedContent>
            <DataContent dependencies={[dataSource]}>
                <PartsSection data={partsData} />
                <ExpensesSection data={expensesData} />
                <DescriptionsSection data={descriptionsData} />
            </DataContent>
        </ExpandedContent>
    );
};
